<template>
  <div class="personal_data">
    <el-dialog :title="$t('myAccount.text21')" v-model="PersonalDataModelFlag" width='500px'
      class="modify_personal_data" destroy-on-close>
      <p class="answers">{{ $t('myAccount.text59') }}</p>
      <div class="personal_data_list">
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text60') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.familyMembersNum" :placeholder="$t('myAccount.text126')"
              style="width: 100%">
              <el-option :value="1" :label="1 + $t('myAccount.text61')">
                1{{ $t('myAccount.text61') }}
              </el-option>
              <el-option :value="2" :label="2 + $t('myAccount.text62')">
                2{{ $t('myAccount.text62') }}
              </el-option>
              <el-option :value="3" :label="3 + $t('myAccount.text62')">
                3{{ $t('myAccount.text62') }}
              </el-option>
              <el-option :value="4" :label="4 + $t('myAccount.text62')">
                4{{ $t('myAccount.text62') }}
              </el-option>
              <el-option :value="5" :label="5 + $t('myAccount.text63')">
                5{{ $t('myAccount.text63') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text64') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.marriedStatus" :placeholder="$t('myAccount.text126')" style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text65')">
                {{ $t('myAccount.text65') }}
              </el-option>
              <el-option :value="2" :label="$t('myAccount.text66')">
                {{ $t('myAccount.text66') }}
              </el-option>
              <el-option :value="3" :label="$t('myAccount.text67')">
                {{ $t('myAccount.text67') }}
              </el-option>
              <el-option :value="4" :label="$t('myAccount.text68')">
                {{ $t('myAccount.text68') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text69') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.profession" :placeholder="$t('myAccount.text126')" style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text70')">
                {{ $t('myAccount.text70') }}
              </el-option>
              <el-option :value="2" :label="$t('myAccount.text71')">
                {{ $t('myAccount.text71') }}
              </el-option>
              <el-option :value="3" :label="$t('myAccount.text72')">
                {{ $t('myAccount.text72') }}
              </el-option>
              <el-option :value="4" :label="$t('myAccount.text73')">
                {{ $t('myAccount.text73') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text74') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.industry" :placeholder="$t('myAccount.text126')" style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text75')">
                {{ $t('myAccount.text75') }}
              </el-option>
              <el-option :value="2" :label="$t('myAccount.text76')">
                {{ $t('myAccount.text76') }}
              </el-option>
              <el-option :value="3" :label="$t('myAccount.text77')">
                {{ $t('myAccount.text77') }}
              </el-option>
              <el-option :value="4" :label="$t('myAccount.text78')">
                {{ $t('myAccount.text78') }}
              </el-option>
              <el-option :value="5" :label="$t('myAccount.text79')">
                {{ $t('myAccount.text79') }}
              </el-option>
              <el-option :value="6" :label="$t('myAccount.text80')">
                {{ $t('myAccount.text80') }}
              </el-option>
              <el-option :value="7" :label="$t('myAccount.text81')">
                {{ $t('myAccount.text81') }}
              </el-option>
              <el-option :value="8" :label="$t('myAccount.text82')">
                {{ $t('myAccount.text82') }}
              </el-option>
              <el-option :value="9" :label="$t('myAccount.text83')">
                {{ $t('myAccount.text83') }}
              </el-option>
              <el-option :value="10" :label="$t('myAccount.text84')">
                {{ $t('myAccount.text84') }}
              </el-option>
              <el-option :value="11" :label="$t('myAccount.text85')">
                {{ $t('myAccount.text85') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text86') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.assets" :placeholder="$t('myAccount.text126')" style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text89') + '100,000USD'">
                {{ $t('myAccount.text134') }}
              </el-option>
              <el-option :value="2" :label="$t('myAccount.text135')">
                {{ $t('myAccount.text135') }}
              </el-option>
              <el-option :value="3" :label="$t('myAccount.text136')">
                {{ $t('myAccount.text136') }}
              </el-option>
              <el-option :value="4" :label="$t('myAccount.text137')">
                {{ $t('myAccount.text137') }}
              </el-option>
              <el-option :value="5" :label="$t('myAccount.text138')">
                {{ $t('myAccount.text138') }}
              </el-option>
              <el-option :value="6" :label="$t('myAccount.text139')">
                {{ $t('myAccount.text139') }}
              </el-option>
              <el-option :value="7" :label="$t('myAccount.text140')">
                {{ $t('myAccount.text140') }}
              </el-option>
              <el-option :value="8" :label="$t('myAccount.text141')">
                {{ $t('myAccount.text141') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text87') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.investTarget" :placeholder="$t('myAccount.text126')" style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text90')">
                {{ $t('myAccount.text90') }}
              </el-option>
              <el-option :value="2" :label="$t('myAccount.text91')">
                {{ $t('myAccount.text91') }}
              </el-option>
              <el-option :value="3" :label="$t('myAccount.text92')">
                {{ $t('myAccount.text92') }}
              </el-option>
              <el-option :value="4" :label="$t('myAccount.text93')">
                {{ $t('myAccount.text93') }}
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="personal_data_list_item">
          <div class="personal_data_list_item_left">
            {{ $t('myAccount.text88') }}
          </div>
          <div :class="locale=='cn'?'personal_data_list_item_right':'personal_data_list_item_right_en'">
            <el-select v-model="personalData.investExperience" :placeholder="$t('myAccount.text126')"
              style="width: 100%">
              <el-option :value="1" :label="$t('myAccount.text89') + '1' + $t('myAccount.text94')">
                {{ $t('myAccount.text89') }}1{{ $t('myAccount.text94') }}
              </el-option>
              <el-option :value="2" :label="'1-2' + $t('myAccount.text95')">
                1-2{{ $t('myAccount.text95') }}
              </el-option>
              <el-option :value="3" :label="'2-3' + $t('myAccount.text95')">
                2-3{{ $t('myAccount.text95') }}
              </el-option>
              <el-option :value="4" :label="'3-5' + $t('myAccount.text95')">
                3-5{{ $t('myAccount.text95') }}
              </el-option>
              <el-option :value="5" :label="$t('myAccount.text96') + '5' + $t('myAccount.text95')">
                {{ $t('myAccount.text96') }} 5 {{ $t('myAccount.text95') }}{{ $t('myAccount.text96_1') }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="PersonalDataModelFlag = false"> {{ $t('trade.text72') }}</el-button>
          <el-button type="primary" :disabled="!submitFlag" @click="sureOK">{{ $t('trade.text73') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>

import {
  ref, reactive, computed, inject, onBeforeUnmount
} from 'vue';
import apiServer from '@/api/request'
import { ElMessage } from 'element-plus'

import { useStore } from 'vuex'
import { useI18n } from "vue-i18n";

export default {
  name: "PersonalData",
  setup() {
    const store = useStore();
    const emitt = inject('emitt');
    const { t } = useI18n()
    const { locale } = useI18n();

    const personalData = reactive({
      familyMembersNum: undefined,
      marriedStatus: undefined,
      profession: undefined,
      industry: undefined,
      assets: undefined,
      investTarget: undefined,
      investExperience: undefined,
    })

    /**
     * 按钮提交条件-开始
     */
    const submitFlag = computed(() => {
      return personalData.familyMembersNum != undefined &&
        personalData.marriedStatus != undefined &&
        personalData.profession != undefined &&
        personalData.industry != undefined &&
        personalData.assets != undefined &&
        personalData.investTarget != undefined &&
        personalData.investExperience != undefined
    })
    /**
     * 按钮提交条件-结束
     */

    /**
     * 提交个人信息-开始
     */
    function sureOK() {
      if (!submitFlag.value) {
        return
      }
      let params = personalData;
      apiServer.PersonalDataEditor(params).then((res) => {
        console.log(res)
        if (res.status == 1) {
          store.dispatch('getUserStatus');
          PersonalDataModelFlag.value = false;
          ElMessage({
            message: t('myAccount.text97'),
            type: 'success',
          })
        }
      })
    }
    /**
     * 提交个人信息-结束
     */


    /*绑定邮箱*/
    //弹框出现/消失
    const PersonalDataModelFlag = ref(false);
    //确认读条
    const confirmLoadingFlag = ref(false);

    //关闭弹框
    function handleCancel() {
      PersonalDataModelFlag.value = false;
    }



    //打开弹框
    emitt.$sub('openPersonalDataModel', () => {
      apiServer.PersonalData().then((res) => {
        Object.assign(personalData, res.data)
      })
      PersonalDataModelFlag.value = true;
    });
    onBeforeUnmount(() => {
      emitt.$unsub("openPersonalDataModel");
    });
    return {
      PersonalDataModelFlag,
      confirmLoadingFlag,
      handleCancel,
      sureOK,
      personalData,
      submitFlag,
      locale
    }
  },
  components: {

  },
}
</script>
<style lang="less" scoped>
.modify_personal_data {
  .personal_data_list {
    .personal_data_list_item {
      height: 32px;
      line-height: 32px;
      margin-top: 16px;
      display: flex;
      justify-content: space-between;

      .personal_data_list_item_left {
        color: @text-color;
        font-size: 14px;
      }

      .personal_data_list_item_right {
        width: 320px;
      }
      .personal_data_list_item_right_en {
        width: 230px;
      }
    }
  }

  .modify_btn {
    height: 40px;
    background: @primary-color;
    border-radius: 2px;
    color: @white;
    line-height: 40px;
    text-align: center;
    margin-top: 24px;
    cursor: pointer;
  }

  .modify_btn_unallow {
    opacity: 0.5;
  }

  .answers {
    font-size: 12px;
    word-break: break-word;
  }
}
</style>
<style lang="less">
.modify_personal_data {

  .el-input__inner,
  .el-button {
    height: 32px;
    /*no*/
    line-height: 32px;
    /*no*/
    font-size: 14px;
    /*no*/
  }
}
</style>
